import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

interface IDashboardProps extends WithTranslation {

}

class Dashboard extends React.Component<IDashboardProps> {
    render() {
        return (
            <div>
                <h1>Welcome to CANCOM Tune</h1>
                <p>Please select a navigation option in the sidebar.</p>
            </div>
        );
    }
}

export default withTranslation()(Dashboard);